// Import CSS
import "../css/index.css";

// Import JS
import InfiniteScroll from 'infinite-scroll';

// Import Table of Contents
import tocbot from 'tocbot';


/**
 * Calculate Scrollbar Width.
 */
const postContent = document.querySelector(".ct-post-content");
if ( postContent ) {
    postContent.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
}


/**
 * Navigation - Handle max menu items.
 */
document.querySelectorAll('.ct-is-submenu > a').forEach(element => {
    element.addEventListener("click", event => {
        event.target.parentNode.classList.toggle('ct-is-active');
        event.preventDefault();
    });
});


/**
 * Remove empty post content divs
 */
document.addEventListener('DOMContentLoaded', function() {
    var postContent = document.querySelector('.ct-page-template .ct-post-content');
    if (postContent && postContent.innerHTML.trim() === '') {
        postContent.remove();
    }
});


/**
 * Remove the # from footer nav headings
 */

// Select all elements with the class .ct-secondary-nav-heading
const elements = document.querySelectorAll('.ct-secondary-nav-heading a');

// Loop through each element
elements.forEach(function(element) {
    // Get the text content of the element
    let text = element.textContent.trim();

    // Check if the text starts with a '#'
    if (text.startsWith('#')) {
        // Remove the first character '#' from the text
        text = text.substring(1);

        // Update the text content of the element
        element.textContent = text;
    }
});


/**
 * Mobile Menu.
 */

// Get the elements once
const navTrigger = document.querySelector('#ct-mobile-nav-trigger');
const closeButton = document.querySelector('#ct-mobile-nav-close');

// Handle nav trigger click
navTrigger?.addEventListener("click", event => {
    document.body.classList.toggle('ct-mobile-nav-active');
    navTrigger.classList.add('ct-hide');
    closeButton?.classList.remove('ct-hide');
    event.preventDefault();
});

// Handle close button click
closeButton?.addEventListener("click", event => {
    document.body.classList.toggle('ct-mobile-nav-active');
    closeButton.classList.add('ct-hide');
    navTrigger?.classList.remove('ct-hide');
    event.preventDefault();
});


/**
 * Account Toggle
 */

const accountToggle = document.querySelector('#ct-account-toggle');
const userMenu = document.querySelector('#ct-user-menu');

// Add click event listener
accountToggle?.addEventListener("click", event => {
    userMenu.classList.toggle('ct-hide');
    event.preventDefault();
});


/**
 * Enable post share button.
 */
import ClipboardJS from 'clipboard';
new ClipboardJS("#copy");


/**
 * Infinite Scroll Load More Button.
 */
document.addEventListener("DOMContentLoaded", function() {
    const gridElements = document.querySelectorAll('.ct-grid'),
        nextPageElement = document.querySelector('.ct-next');

    if ( nextPageElement && gridElements.length ) {
        const gridElement = gridElements[gridElements.length - 1];

        const infScroll = new InfiniteScroll( gridElement, {
            path: '.ct-next',
            append: '.ct-item',
            button: '.ct-load-more',
            hideNav: '.ct-next',
            history: false,
            scrollThreshold: false,
        });

        infScroll.on('append', function(response, path, items) {
            for (var i = 0; i < items.length; i++) {
                reloadSrcsetImgs(items[i]);
            }
        });

        function reloadSrcsetImgs(item) {
            var imgs = item.querySelectorAll('img[srcset]');
            for (var i = 0; i < imgs.length; i++) {
                var img = imgs[i];
            }
        }
    }
});

/**
 * Show the first Sunday Special
 */
if( document.querySelectorAll('.ct-sunday-special')[0]) document.querySelectorAll('.ct-sunday-special')[0].querySelector('p').classList.remove('ct-hide');

/**
* Expand & Collapse Homepage Sections
*/
var navElements = document.querySelectorAll('.home-template .ct-feature-post-list');

// Function to save state to localStorage
function saveState(id, state) {
    localStorage.setItem(`postListState_${id}`, state);
}

// Function to load state from localStorage
function loadState(id) {
    return localStorage.getItem(`postListState_${id}`) === 'collapsed';
}

navElements.forEach(function(element, index) {
    document.addEventListener('DOMContentLoaded', () => {
        const collapseAction = element.querySelector('.ct-section-collapse-action');
        const expandAction = element.querySelector('.ct-section-expand-action');
        const postList = element.querySelector('.ct-post-list');

        // Unique identifier for each element (in case there are multiple lists)
        const elementId = element.id || `featurePostList_${index}`;
        element.setAttribute('id', elementId);

        // Apply the saved state on page load
        if (loadState(elementId)) {
            element.classList.add('collapsed');
        } else {
            element.classList.remove('collapsed');
        }

        if (postList) {
            if (collapseAction) {
                collapseAction.addEventListener('click', () => {
                    element.classList.add('collapsed');
                    saveState(elementId, 'collapsed');
                });
            }

            if (expandAction) {
                expandAction.addEventListener('click', () => {
                    element.classList.remove('collapsed');
                    saveState(elementId, 'expanded');
                });
            }
        }
    });
});


/**
* Tags Page
*
* Group tags list items alphabetically and add first letter headings to the groupings.
*/

document.addEventListener("DOMContentLoaded", function() {
    const tagsIndex =  document.querySelector('.ct-tags-index');

    if ( tagsIndex ) {
        // Select the container and all .ct-item elements within it
        const container = document.querySelector('.ct-tags-index .ct-post-list');
        const items = Array.from(container.querySelectorAll('.ct-tags-index .ct-item'));

        // Sort the items based on the data-slug attribute
        /*items.sort((a, b) => {
            const slugA = a.getAttribute('data-slug');
            const slugB = b.getAttribute('data-slug');
            return slugA.localeCompare(slugB);
        });*/

        // Clear the container to prepare for grouping
        container.innerHTML = '';

        // Track the current group letter
        let currentGroup = '';

        // Append grouped items back to the container with headers
        items.forEach(item => {
            const slug = item.getAttribute('data-slug');
            const groupLetter = slug.charAt(0).toUpperCase(); // Get the first letter and capitalize

            // If we're in a new group, add an <h4> header
            if (groupLetter !== currentGroup) {
                const header = document.createElement('h4');
                header.textContent = groupLetter;
                container.appendChild(header);
                currentGroup = groupLetter; // Update the current group
            }

            // Append the item to the container
            container.appendChild(item);
        });
    }
});

/**
 * Table of Contents
 */
tocbot.init({
    // Your configuration options here
    tocSelector: '.js-post-toc',
    contentSelector: '.ct-post-content',
    headingSelector: 'h1, h2, h3, h4, h5, h6',
    collapseDepth: 0, // Ensures no subheadings are shown
    hasInnerContainers: false
});

/**
 * Membership 19% tag
 */
document.addEventListener("DOMContentLoaded", function () {
    // Select all membership card

    const membershipCards = document.querySelectorAll('.ct-membership-card:not([data-free-tier])');

    if (membershipCards.length > 0) {
        // Function to create and append the save element
        const appendSaveTag = (card, text, attributes = {}) => {
            const paragraph = card.querySelector('.ct-membership-card-excerpt');
            if (paragraph) {
                const smallElement = document.createElement('small');
                smallElement.textContent = text;

                // Add attributes dynamically
                Object.entries(attributes).forEach(([key, value]) => {
                    smallElement.setAttribute(key, value);
                });
                paragraph.appendChild(smallElement);
            }
        };

        // Loop through each membership card
        membershipCards.forEach((card) => {
            // Get the text content of the h2 element inside the card
            const cardTitle = card.querySelector('h2')?.textContent || '';

            // Check if the title does NOT include "Free"
            if (!cardTitle.toLowerCase().includes('free')) {
                // Add the savings badge with attributes
                appendSaveTag(card, 'Go yearly, save 19%', { 'data-monthly': '' });
                appendSaveTag(card, 'Save 19%', { 'data-yearly': '', class: 'ct-saving-active' });
            }
        });
    }
});


/**
 * Membership Tier Linking
 */
document.addEventListener("DOMContentLoaded", function () {
    // Check if linked_tiers is defined
    if (typeof linked_tiers !== "undefined") {
        linked_tiers.forEach((tier) => {
            // Find the checkbox and its related data attributes by original_plan_id
            const escapedId = CSS.escape(`${tier.original_plan_id}-upsell`);
            const checkbox = document.querySelector(`#${escapedId}`);

            if (checkbox) {
                // Update checkbox attributes dynamically
                checkbox.setAttribute("data-original-plan-id", tier.original_plan_id);
                checkbox.setAttribute("data-linked-plan-id", tier.linked_plan_id);
                checkbox.setAttribute("data-linked-monthly", tier.linked_plan_monthly);
                checkbox.setAttribute("data-linked-yearly", tier.linked_plan_yearly);

                // Update the data-yearly and data-monthly attributes in the corresponding <small> tags
                const yearlySmall = checkbox.closest(".ct-membership-bundle").querySelector("small[data-yearly]");
                const monthlySmall = checkbox.closest(".ct-membership-bundle").querySelector("small[data-monthly]");

                if (yearlySmall) {
                    yearlySmall.setAttribute("data-yearly", `$${tier.linked_plan_yearly}/yr`);
                    yearlySmall.textContent = `+$${tier.linked_plan_yearly}/yr`;
                }

                if (monthlySmall) {
                    monthlySmall.setAttribute("data-monthly", `$${tier.linked_plan_monthly}/mo`);
                    monthlySmall.textContent = `+$${tier.linked_plan_monthly}/mo`;
                }
            }
        });
    }
});


/**
 * Membership tier checkbox
 */

document.querySelectorAll('.ct-membership-card').forEach(card => {
    // Find the checkbox within this card
    const checkbox = card.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    // Get ALL subscription buttons within this card
    const monthlyBtns = card.querySelectorAll(`[data-portal$="/monthly"]`);
    const yearlyBtns = card.querySelectorAll(`[data-portal$="/yearly"]`);

    // Get ALL price elements
    const monthlyPrices = card.querySelectorAll('[data-monthly] price');
    const yearlyPrices = card.querySelectorAll('[data-yearly] price');

    // Store original values for this card
    const originalValues = {
        monthlyPrices: Array.from(monthlyPrices).map(price => price.textContent),
        yearlyPrices: Array.from(yearlyPrices).map(price => price.textContent),
        planId: checkbox.dataset.originalPlanId,
        monthlyPortals: Array.from(monthlyBtns).map(btn => btn.getAttribute('data-portal')),
        yearlyPortals: Array.from(yearlyBtns).map(btn => btn.getAttribute('data-portal'))
    };

    // Handle checkbox changes for this card
    checkbox.addEventListener('change', function() {
        if (this.checked) {
            // Add the linked plan amounts to the original prices
            const newMonthlyPrice = parseInt(originalValues.monthlyPrices[0]) + parseInt(this.dataset.linkedMonthly);
            const newYearlyPrice = parseInt(originalValues.yearlyPrices[0]) + parseInt(this.dataset.linkedYearly);

            // Update all price elements
            monthlyPrices.forEach(price => {
                price.textContent = newMonthlyPrice;
            });
            yearlyPrices.forEach(price => {
                price.textContent = newYearlyPrice;
            });

            // Update plan IDs in all portal links
            const linkedPlanId = this.dataset.linkedPlanId;
            monthlyBtns.forEach(btn => {
                btn.setAttribute('data-portal', `signup/${linkedPlanId}/monthly`);
            });
            yearlyBtns.forEach(btn => {
                btn.setAttribute('data-portal', `signup/${linkedPlanId}/yearly`);
            });
        } else {
            // Reset all price elements to their original values
            monthlyPrices.forEach((price, index) => {
                price.textContent = originalValues.monthlyPrices[index];
            });
            yearlyPrices.forEach((price, index) => {
                price.textContent = originalValues.yearlyPrices[index];
            });

            // Reset all portal URLs to their original values
            monthlyBtns.forEach((btn, index) => {
                btn.setAttribute('data-portal', originalValues.monthlyPortals[index]);
            });
            yearlyBtns.forEach((btn, index) => {
                btn.setAttribute('data-portal', originalValues.yearlyPortals[index]);
            });
        }
    });
});

/**
 * Membership included/excluded logic
document.addEventListener("DOMContentLoaded", function () {
    // Define the new SVG for all new <li> elements
    const newSVG = `
        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.800781" width="28" height="28" rx="14" fill="#F9F9F9"/>
            <path d="M8.66797 10.3008L19.168 20.8008" stroke="#B7B7B7" stroke-width="2" stroke-linecap="round"/>
            <path d="M19.168 10.3008L8.66797 20.8008" stroke="#B7B7B7" stroke-width="2" stroke-linecap="round"/>
        </svg>`;

    // Select all the membership card lists
    const cardLists = document.querySelectorAll(".ct-membership-card-list");

    // Proceed only if there are at least 2 lists
    if (cardLists.length >= 2) {

        // Assume the last list is the reference list
        const referenceList = cardLists[cardLists.length - 1];

        // Get all <li> elements in the third list
        const thirdListItems = Array.from(referenceList.querySelectorAll("li"));

        // Loop through all other lists (excluding the third list)
        cardLists.forEach((list, index) => {
            if (index !== 2) {
                // Get all <li> text content in the current list
                const existingItems = Array.from(list.querySelectorAll("li")).map((li) => li.textContent.trim());

                // Loop through the <li> elements in the third list
                thirdListItems.forEach((thirdLi) => {
                    // If the <li>'s text doesn't exist in the current list, add it
                    if (!existingItems.includes(thirdLi.textContent.trim())) {
                        // Clone the <li>
                        const newLi = thirdLi.cloneNode(true);

                        newLi.classList.add('ct-excludes'); // Add the 'active' class

                        // Replace its SVG with the new SVG
                        const svg = newLi.querySelector("svg");
                        if (svg) {
                            svg.outerHTML = newSVG;
                        }

                        // Append the modified <li> to the current list
                        list.appendChild(newLi);
                    }
                });
            }
        });
    }
});
*/

/**
 * Infinite Scroll Load More Button.
 */
document.addEventListener("DOMContentLoaded", function() {
    const gridElements = document.querySelectorAll('.ct-grid'),
        nextPageElement = document.querySelector('.ct-next');

    if ( nextPageElement && gridElements.length ) {
        const gridElement = gridElements[gridElements.length - 1];

        const infScroll = new InfiniteScroll( gridElement, {
            path: '.ct-next',
            append: '.ct-item',
            button: '.ct-load-more',
            hideNav: '.ct-next',
            history: false,
            scrollThreshold: false,
            status: '.page-load-status',
            debug: false
        });

        infScroll.on('append', function(response, path, items) {
            for (var i = 0; i < items.length; i++) {
                reloadSrcsetImgs(items[i]);
            }
        });

        function reloadSrcsetImgs(item) {
            var imgs = item.querySelectorAll('img[srcset]');
            for (var i = 0; i < imgs.length; i++) {
                var img = imgs[i];
            }
        }

        /**
        * Archive Page
        *
        * Group archive list items by month and add headings to the groupings e.g. June 2024.
        */
        if ( document.querySelector('.ct-posts-archive') ) {
            addArchiveListHeadings();
            infScroll.on('append', addArchiveListHeadings);

            function addArchiveListHeadings() {
                const postList = document.querySelector('.ct-post-list.ct-grid');
                if (!postList) return;

                const archiveItems = Array.from(postList.querySelectorAll('.ct-item'));
                let currentMonth = '';

                archiveItems.forEach((item) => {
                    const month = item.getAttribute('data-month');

                    // Check if the header already exists
                    const existingHeader = postList.querySelector(
                        `.ct-archive-posts-header[data-header-month="${month}"]`
                    );

                    if (month !== currentMonth && !existingHeader) {
                        currentMonth = month;

                        // Create and insert the <div> header with data-header-month attribute
                        const header = document.createElement('div');
                        header.className = 'ct-archive-post-item ct-post-list ct-archive-posts-header';
                        header.setAttribute('data-header-month', month);
                        header.textContent = month;
                        postList.insertBefore(header, item);
                    }
                });
            }
        }
    }
});

/**
 * Handle Intro Overlay
 */

const INTRO_EXPIRY = 86400; // 1 day

const handleIntroOverlay = () => {
    const _handleIntro = () => {
        document.documentElement.setAttribute('data-intro', 'hidden');
        document.body.classList.remove('is-overflowY-hidden');

        const userIntroPreference = {
            value: 'hidden',
            expiry: Date.now() + INTRO_EXPIRY * 1000,
        };
        localStorage.setItem('USER_INTRO', JSON.stringify(userIntroPreference));
    };

    const intro = document.querySelector('.js-intro');
    if (!intro) {
        return;
    }

    let userIntroPreference;
    try {
        userIntroPreference = JSON.parse(localStorage.getItem('USER_INTRO', 'null'));
    } catch (_e) {
        userIntroPreference = null;
    }

    if (!userIntroPreference || (userIntroPreference.value && Date.now() > userIntroPreference.expiry)) {
        // Show the intro by default when no preference or expired
        document.documentElement.setAttribute('data-intro', 'visible');
        document.body.classList.add('is-overflowY-hidden');
    } else if (userIntroPreference.value === 'hidden') {
        // Only hide if explicitly set to hidden
        document.documentElement.setAttribute('data-intro', 'hidden');
        document.body.classList.remove('is-overflowY-hidden');
    }

    const introClose = document.querySelector('.js-intro-close');
    if (introClose) {
        introClose.onclick = _handleIntro;
    }

    const introArchive = document.querySelector('.js-intro-archive');
    if (introArchive) {
        introArchive.onclick = _handleIntro;
    }
}

/**
* Handle Image Gallery
*/
const handleImageGallery = () => {
  const images = document.querySelectorAll('.kg-image-card img, .kg-gallery-card img');
  const galleryImages = document.querySelectorAll('.kg-gallery-image img');

  // Gallery style
  galleryImages.forEach(image => {
    var container = image.closest('.kg-gallery-image');
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = `${ratio} 1 0%`;
  })

  // Lighbox function
  if (CONFIG.ENABLE_IMAGE_LIGHTBOX) {
    images.forEach(image => {
      const link = image.parentNode.nodeName === 'A' ? image.parentNode.getAttribute('href') : '';
      var lightboxWrapper = link ? image.parentNode : document.createElement('a');

      lightboxWrapper.setAttribute('data-no-swup', '');
      lightboxWrapper.setAttribute('data-fslightbox', '');
      lightboxWrapper.setAttribute('href', image.src);
      lightboxWrapper.setAttribute('aria-label', 'Click for Lightbox');

      if (link) {
        var linkButton = document.createElement('a');
        linkButton.innerHTML = `<i class="icon icon-link icon--sm"><svg class="icon__svg"><use xlink:href="/assets/icons/icon-sprite.svg#link"></use></svg></i>`
        linkButton.setAttribute('class', 'image-link');
        linkButton.setAttribute('href', link);
        if (CONFIG.OPEN_LINKS_IN_NEW_TAB) {
          linkButton.setAttribute('target', '_blank');
          linkButton.setAttribute('rel', 'noreferrer noopener');
        }
        lightboxWrapper.parentNode.insertBefore(linkButton, lightboxWrapper.parentNode.firstChild);
      } else {
        image.parentNode.insertBefore(lightboxWrapper, image.parentNode.firstChild);
        lightboxWrapper.appendChild(image);
      }
    });

    refreshFsLightbox();
  };
}

/**
 * Splash Page Submission
 */

// Add this script at the end of your page or in your theme's JavaScript file
document.addEventListener('DOMContentLoaded', function() {
    // Get your specific form with the class "spash-page"
    const splashPageForm = document.querySelector('.subscribe-form.spash-page');

    if (splashPageForm) {
        // Create a MutationObserver to watch for class changes
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Check if the mutation is a class attribute change
                if (mutation.attributeName === 'class') {
                    // Check if the form now has the 'success' class
                    if (splashPageForm.classList.contains('success')) {
                        // Wait a moment to show the success message, then redirect
                        setTimeout(function() {

                            let changeUserIntro = {
                                value: 'hidden',
                                expiry: Date.now() + INTRO_EXPIRY * 1000,
                            };
                            localStorage.setItem('USER_INTRO', JSON.stringify(changeUserIntro));

                            window.location.href = '/';
                        }, 5000); // 2 second delay

                        // Disconnect the observer since we don't need it anymore
                        observer.disconnect();
                    }
                }
            });
        });

        // Start observing the form for class changes
        observer.observe(splashPageForm, { attributes: true });
    }
});

/**
 * Load Member Newsletters
 */
const loadMemberNewsletters = async () => {
    console.log('Loading member newsletters');
    // Get the current member's ID from the page context
    const memberElement = document.querySelector('[data-member-id]');
    if (!memberElement) return;

    const memberId = memberElement.getAttribute('data-member-id');
    

    // Make API call to Ghost Admin API
    const response = await fetch(`/members/api/member/?include=newsletters%2Clabels&filter=id:${memberId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            // Add authorization header if needed
            // 'Authorization': 'Bearer YOUR_ADMIN_API_KEY'
        }
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const member = await response.json();
    console.log(member);

    if (member && member.newsletters) {
        // Update newsletter checkboxes based on API response
        updateNewsletterCheckboxes(member.newsletters);
    }
};

/**
 * Update Newsletter Checkboxes
 */
const updateNewsletterCheckboxes = (newsletters) => {
    const newsletterForm = document.querySelector('#newsletter-form');
    if (!newsletterForm) return;

    // Temporarily disable form updates during initial load
    newsletterForm.setAttribute('data-initial-loading', 'true');
    
    const checkboxes = newsletterForm.querySelectorAll('input[type="checkbox"]');
    
    // Loop through the newsletters object
    newsletters.forEach(newsletter => {
        console.log(newsletter.id);
        // If the ID of the newsletter exists on our form, check the box
        const checkbox = newsletterForm.querySelector(`input[data-newsletter-id="${newsletter.id}"]`);
        if (checkbox) {
            checkbox.checked = true;
            console.log(checkbox);
        }
    });
    
    // Re-enable form updates after initial load
    setTimeout(() => {
        newsletterForm.removeAttribute('data-initial-loading');
    }, 100);
};

/**
 * Handle Newsletter Form Submission
 */
const handleNewsletterForm = () => {
    const form = document.getElementById('newsletter-form');
    if (!form) return;

    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    
    // Add change event listener to each checkbox
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', async (e) => {
            form.setAttribute('disabled', 'true');

            // Skip updates during initial loading
            if (form.getAttribute('data-initial-loading') === 'true') {
                return;
            }
            
            const memberElement = document.querySelector('[data-member-id]');
            if (!memberElement) return;
            
            const memberId = memberElement.getAttribute('data-member-id');
            const checkedBoxes = form.querySelectorAll('input[type="checkbox"]:checked');
            
            // Build the newsletters array with only checked newsletter IDs
            const newsletters = Array.from(checkedBoxes).map(cb => ({
                id: cb.getAttribute('data-newsletter-id')
            }));
            
            // Show loading message
            const loadingMsg = form.querySelector('.ct-loading-message');
            const successMsg = form.querySelector('.ct-success-message');
            const errorMsg = form.querySelector('.ct-error-message');
            
            loadingMsg.style.display = 'block';
            successMsg.style.display = 'none';
            errorMsg.style.display = 'none';
            
            try {
                const response = await fetch(`/members/api/member/${memberId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ newsletters })
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                // Show success message
                loadingMsg.style.display = 'none';
                successMsg.style.display = 'block';
                
                // Hide success message after 3 seconds
                setTimeout(() => {
                    successMsg.style.display = 'none';
                    form.removeAttribute('disabled');
        
                }, 3000);
                
            } catch (error) {
                console.error('Error updating newsletters:', error);
                
                // Show error message
                loadingMsg.style.display = 'none';
                errorMsg.style.display = 'block';
                
                // Revert checkbox state on error
                checkbox.checked = !checkbox.checked;
                
                // Hide error message after 3 seconds
                setTimeout(() => {
                    errorMsg.style.display = 'none';
                    form.removeAttribute('disabled');
                }, 3000);
            }
        });
    });
};

/**
* DOM Loaded event
*/
const callback = () => {
  // handleImageGallery();
  
  // Load member newsletters if on account page
  if (document.querySelector('[data-member-id]')) {
    loadMemberNewsletters();
    handleNewsletterForm();
  }
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener('DOMContentLoaded', callback);
}


handleIntroOverlay();